import {
    Button,
    ButtonIcon,
    ButtonText,
    Checkbox,
    CheckboxIcon,
    CheckboxIndicator,
    CheckboxLabel,
    CogIcon,
    Dropdown,
    DropdownMenuItem
} from "@hosttools/frontend";
import type {IMenuProps} from "@hosttools/frontend";
import type {Column, VisibilityState} from "@tanstack/react-table";
import type React from "react";
import {memo, useCallback} from "react";

type Props = {
    columns: Column<{}, unknown>[];
    columnVisibility: VisibilityState;
};

const EditColumns: React.FC<Props> = ({columns, columnVisibility}) => {
    const triggerListingDropdown = useCallback((triggerProps: IMenuProps["trigger"]) => {
        return (
            <Button {...triggerProps} action="secondary" size="sm" variant="outline">
                <ButtonIcon as={CogIcon} />
                <ButtonText>Edit Columns</ButtonText>
            </Button>
        );
    }, []);

    return (
        <Dropdown closeOnSelect={false} trigger={triggerListingDropdown}>
            {columns.map(column => (
                <DropdownMenuItem key={column.id} onPress={() => column.toggleVisibility()}>
                    <Checkbox
                        isChecked={columnVisibility[column.id] || column.getIsVisible()}
                        value={column.id}
                        onChange={column.toggleVisibility}
                    >
                        <CheckboxIndicator>
                            <CheckboxIcon />
                        </CheckboxIndicator>
                        <CheckboxLabel>
                            {typeof column.columnDef.header !== "function"
                                ? column.columnDef.header
                                : null}
                        </CheckboxLabel>
                    </Checkbox>
                </DropdownMenuItem>
            ))}
        </Dropdown>
    );
};

export default memo(EditColumns);
